export default class OrderViewController {
  constructor(OrdersDataProvider, $state, $timeout, APPLICATION_URL, UNIFAUN_ID, UNIFAUN_SECRET) {
    "ngInject"
    this.OrdersDataProvider = OrdersDataProvider;
    this.$state = $state;
    this.$timeout = $timeout;
    this.APPLICATION_URL = APPLICATION_URL;
    this.UNIFAUN_ID = UNIFAUN_ID;
    this.UNIFAUN_SECRET = UNIFAUN_SECRET;
    this.errorShow = 0;
    this.shipShow = 0;
    this.parcelsCopies = 1;
    this.Math = Math;
    this.fromEmail = "info@signlabs.se";

    let currency = [];
    currency['default'] = 'kr';
    currency['signlabs.se'] = 'SEK';
    currency['signlabs.dk'] = 'DKK';
    currency['signlabs.no'] = 'NOK';
    currency['signlabs.fi'] = 'EUR';
    currency['signlabs.de'] = 'EUR';
    currency['signlabs.at'] = 'EUR';
    currency['signlabs.ch'] = 'EUR';
    currency['signlabs.es'] = 'EUR';
    currency['signlabs.fr'] = 'EUR';
    currency['signlabs.it'] = 'EUR';
    currency['signlabs.nl'] = 'EUR';
    currency['signlabs.be'] = 'EUR';
    currency['signlabs.pl'] = 'PLN';
    currency['signlabs.eu'] = 'EUR';
    currency['signlabs.co.uk'] = 'GBP';
    currency['signlabs.com'] = 'USD';
    currency['signlabs.loc'] = 'SEK';

    let currencyDivider = [];
    currencyDivider['default'] = ",";
    currencyDivider['signlabs.se'] = ",";
    currencyDivider['signlabs.dk'] = ",";
    currencyDivider['signlabs.no'] = ",";
    currencyDivider['signlabs.fi'] = ".";
    currencyDivider['signlabs.de'] = ".";
    currencyDivider['signlabs.at'] = ".";
    currencyDivider['signlabs.ch'] = ".";
    currencyDivider['signlabs.es'] = ".";
    currencyDivider['signlabs.fr'] = ".";
    currencyDivider['signlabs.it'] = ".";
    currencyDivider['signlabs.nl'] = ".";
    currencyDivider['signlabs.be'] = ".";
    currencyDivider['signlabs.pl'] = ".";
    currencyDivider['signlabs.eu'] = ".";
    currencyDivider['signlabs.co.uk'] = ".";
    currencyDivider['signlabs.com'] = ",";
    currencyDivider['signlabs.loc'] = ",";

    let
      vm = this;
    OrdersDataProvider.getOrder($state.params.id).then(function (result) {
      result.currency = currency['default'];
      
      if(result.site_domain){
        if(result.site_domain == "localhost:8000"){
          result.site_domain = "signlabs.se";
        }
        result.currency = currency[result.site_domain];
        result.currencyDivider = currencyDivider[result.site_domain]
      }else{
        result.currencyDivider = ",";
      }
      if(!result.currency_rate){
        result.currency_rate = 1;
      }

      vm.data = result;
      //vm.cFormat(result);
      let
        domainSplit = result.domain.split(".");
      vm.domain = domainSplit.pop().toUpperCase();
      if (!vm.data.s_company_name)
        vm.data.s_company_name = vm.data.company_name;
      if (!vm.data.s_fullName)
        vm.data.s_fullName = vm.data.fullName;
      if (!vm.data.s_street)
        vm.data.s_street = vm.data.street;
      if (!vm.data.s_locality)
        vm.data.s_locality = vm.data.locality;
      if (!vm.data.s_zipCode)
        vm.data.s_zipCode = vm.data.zipCode;
      if (!vm.data.s_country)
        vm.data.s_country = vm.data.countryCode;
      if (!vm.data.s_phoneNumber)
        vm.data.s_phoneNumber = vm.data.phoneNumber;
      vm.phoneNumberShipp = vm.data.s_phoneNumber.replace(/-|\s/g, "");

      if (vm.data.invoice_cost) {
        vm.data.invoice_fee = vm.data.invoice_cost;
      }
      if(vm.data.invoice_type == 1) {
        vm.data.invoice_type_value = "Email";
      }else{
        vm.data.invoice_type_value = "Paper";
      }
      vm.mydate = new Date(vm.data.created_at);
      vm.data.due_date = angular.copy(vm.mydate);

      if(vm.data.invoice_created_at == null){
        vm.data.invoice_due_date = new Date();
        vm.data.invoice_due_date.setDate(vm.data.invoice_due_date.getDate() + 20);
      }else{
        vm.data.invoice_due_date = new Date(vm.data.invoice_created_at);
        vm.data.invoice_due_date.setDate(vm.data.invoice_due_date.getDate() + 20);
      }
      if (!result.delivery_time)
        result.delivery_time = '3-5';
      vm.delivery_time = result.delivery_time.split("-");
      let
        numberOfDaysToAdd = vm.delivery_time[1];
      vm.data.due_date.setDate(vm.data.due_date.getDate() + parseInt(numberOfDaysToAdd));
      //remove sat sunday
      let currentDate = vm.mydate;
      let fromDate = angular.copy(vm.mydate);
      let toDate = angular.copy(vm.data.due_date);
      for (var d = fromDate; d <= toDate; d.setDate(d.getDate() + 1)) {
        currentDate = new Date(d);
        if (currentDate.getDay() == 0 || currentDate.getDay() == 6) {
          vm.data.due_date.setDate(vm.data.due_date.getDate() + 1);
        }
      }
      if (vm.data.due_date.getDay() == 0)
        vm.data.due_date.setDate(vm.data.due_date.getDate() + 1);
      if (vm.data.due_date.getDay() == 6)
        vm.data.due_date.setDate(vm.data.due_date.getDate() + 2);

      vm.discountAmt = ((result.grand_total * result.discount_percent) / 100);
      if (!result.coupon_price)
        result.coupon_price = 0;
      vm.total = (result.grand_total - (parseFloat(vm.discountAmt) + parseFloat(result.coupon_price))) + (result.delivery_price / vm.data.currency_rate);

      // vm.data.amount_part1 = Math.floor(result.amount);
      // let decimal = (result.amount - Math.floor(result.amount)).toFixed(2);
      // vm.data.amount_part2 = Number(decimal.substring(2));

      if (result.orderType == "Invoice")
        vm.total += (result.invoice_fee / vm.data.currency_rate);
      vm.vatAmt = ((vm.total * result.vat_percent) / 100);
      vm.getStatusLog(result.order_id);
	  
	  /*
      OrdersDataProvider.getItems(result.order_id).then(function (items) {
        vm.items = items;
        let
          itemMax = '';
        vm.totalWeight = 0;
        if (items.length > 1) {
          itemMax = items.reduce(function (prev, current) {
            return ((prev.width * prev.height) > (current.width * prev.height)) ? (prev.width + 'mm-' + prev.height + 'mm') : (current.width + 'mm-' + current.height + 'mm')
          });
        }
        else if (items.length == 1) {
          itemMax = items[0].width + 'mm-' + items[0].height + 'mm';
          //let
          //weight=items[0].weight;
          //items[0].weight=Math.ceil(weight);
        }
        for (var key in items) {
          vm.totalWeight += parseFloat(items[key].weight*items[key].quantity);
        }
        //vm.parcelsWeight = Math.ceil(vm.totalWeight);
        //vm.parcelsWeight = vm.totalWeight < 80 ? 50 : (vm.totalWeight >= 80 && vm.totalWeight < 150) ? 100 : Math.ceil(vm.totalWeight);
		vm.parcelsWeight = (vm.totalWeight + 20) < 80 ? 50 : ((vm.totalWeight + 20) >= 80 && (vm.totalWeight + 20) < 150) ? 100 : Math.ceil(vm.totalWeight + 20);
		vm.itemMaxWH = itemMax.split('-');
      });
	  */
	  
	  /* Denna fungerar!
	  OrdersDataProvider.getItems(result.order_id).then(function (items) {
  vm.items = items;
  let maxWidthItem = null;
  let maxHeightItem = null;
  vm.totalWeight = 0;

  // Loopa igenom objekten för att hitta det objekt med största bredd och det objekt med största höjd
  for (var i = 0; i < items.length; i++) {
    if (!maxWidthItem || items[i].width > maxWidthItem.width) {
      maxWidthItem = items[i];
    }
    if (!maxHeightItem || items[i].height > maxHeightItem.height) {
      maxHeightItem = items[i];
    }

    vm.totalWeight += parseFloat(items[i].weight * items[i].quantity);
  }

  // Beräkna vikten för paket (parcelsWeight) på samma sätt som tidigare
  vm.parcelsWeight = (vm.totalWeight + 20) < 80 ? 50 :
                     ((vm.totalWeight + 20) >= 80 && (vm.totalWeight + 20) < 150) ? 100 :
                     Math.ceil(vm.totalWeight + 20);

  // Sätt 'itemMaxWH' till det objekt med största bredd och det objekt med största höjd
  vm.itemMaxWH = [maxWidthItem.width + 'mm', maxHeightItem.height + 'mm'];
});
*/
OrdersDataProvider.getItems(result.order_id).then(function (items) {
  vm.items = items;
  let maxWidthItem = null;
  let maxHeightItem = null;
  vm.totalWeight = 0;

  // Loopa igenom objekten för att hitta det objekt med största bredd och det objekt med största höjd
  for (var i = 0; i < items.length; i++) {
    if (!maxWidthItem || items[i].width > maxWidthItem.width) {
      maxWidthItem = items[i];
    }
    if (!maxHeightItem || items[i].height > maxHeightItem.height) {
      maxHeightItem = items[i];
    }

    vm.totalWeight += parseFloat(items[i].weight * items[i].quantity);
  }

  // Lägg till vikter baserat på bredd och höjd
  if (maxWidthItem.width < 311 || maxHeightItem.height < 311) {
    vm.totalWeight += 46;
  } else if ((maxWidthItem.width >= 311 && maxWidthItem.width < 387) || (maxHeightItem.height >= 311 && maxHeightItem.height < 387)) {
    vm.totalWeight += 88;
  } else if (maxWidthItem.width >= 387 || maxHeightItem.height >= 387) {
    vm.totalWeight += 172;
  }

  // Uppdatera vm.parcelsWeight enligt de nya beräkningarna
  vm.parcelsWeight = (vm.totalWeight) < 80 ? 50 :
                     ((vm.totalWeight) >= 80 && (vm.totalWeight) < 150) ? 100 :
                     Math.ceil(vm.totalWeight);
					 
  // Sätt 'itemMaxWH' till det objekt med största bredd och det objekt med största höjd
  vm.itemMaxWH = [maxWidthItem.width + 'mm', maxHeightItem.height + 'mm'];
});

      OrdersDataProvider.getComments(result.order_id).then(function (comments) {
        vm.comments = comments;
      });
    });
    // countries
    let
      theUrl = vm.APPLICATION_URL + '/api/get/countries';
    let
      xmlHttp = new XMLHttpRequest();
    xmlHttp.open("GET", theUrl, false); // false for synchronous request
    xmlHttp.send(null);
    vm.countries = JSON.parse(xmlHttp.response);
    // shipping
    vm.checkShippingService('BREVPOST');
  }

  priceFormat(amount){
    let vm = this.data;
    return amount ? ((amount * vm.currency_rate).toFixed(2)).replace(".",vm.currencyDivider)+" "+vm.currency : 0;
  }
    priceFormatLocal(amount){
    let vm = this.data;
    return amount ? ((amount).toFixed(2)).replace(".",vm.currencyDivider)+" "+vm.currency : 0;
  }
  checkShippingService(id) {
    this.checkboxs = {};
    this.selected = [];
    this.checkboxsOpt = {};
    this.selectedOpt = [];
    this.othersOpt = {};
    this.selectedOthrOpt = [];
    this.disabled = -1;
    this.disableCN = -1;
    let vm = this;

    if (id == 'P19' || id == 'P17' || id == 'P91' || id == 'PUA' || id == 'DPD' || id == 'P18' || id == 'BPA' || id == 'BCF' || id == 'BHP') {
      vm.checkboxsOpt = {'ENOT': 'Föravisering (E-post)'}
      vm.selectedOpt = [{
        "message": "OrderNo: " + vm.data.orderId,
        "to": vm.data.s_email,
        "id": "ENOT",
        "languageCode": "SE",
        "from": vm.fromEmail
      }];
    }
    if (id == 'BREVPOST') {
      vm.checkboxs = {'PRIO': '1:a-klass brev', 'EBREV': 'Ekonomibrev', 'SPXL': 'Skrymmande'};
      vm.selected = [{"id": "PRIO"}];
    }
    if (id == 'P18') {
      vm.checkboxs = {"PRENOT": "Föravisering"};
    }
    if (id == 'P19' || id == 'PUA') {
      vm.checkboxs = {'NOTSMS': 'SMS-avisering', 'NOTEMAIL': 'E-postavisering'};
      vm.selected = [];
    }
    if (id == 'BREKD') {
      vm.checkboxs = {"NOTSMS": "SMS-avisering"};
      vm.selected = [{"id": "NOTSMS", "misc": vm.phoneNumberShipp}];
    }
    if (id == 'BREKI') {
      vm.checkboxs = {'NOINSU': 'REK 2000', 'INSU': 'REK 10000'};
      vm.selected = [{"id": "NOINSU"}];
    }
    if (id == 'P17') {
      vm.checkboxs = {'DLVNOT': 'Leveransavisering'};
      vm.selected = [{"id": "DLVNOT", "text3": vm.phoneNumberShipp, "text4": vm.data.s_email}];
    }
    if (id == 'P34') {
      vm.checkboxs = {'NOTMAXI': 'Ej Maxi'};
      vm.selected = [];
    }
    //others
    if (id == 'P19' || id == 'P18' || id == 'BREVPOST' || id == 'BREKI' || id == 'PUA') {
      vm.othersOpt = {"CN22": "CN22", "CN23": "CN23"};
    }
    if (id == 'P34') {
      vm.othersOpt = {"CN22": "CN22", "CN23": "CN23"};
    }
    if (id == 'P91' || id == 'BPA' || id == 'BCF' || id == 'BHP') {
      vm.othersOpt = {"CN22": "CN22", "CN23": "CN23"};
    }
  }

  toggle(checkbox, list, opt) {
    let
      vm = this;
    let
      index = list.findIndex(function (el) {
        return (el.id === checkbox);
      });
    if (index > -1) {
      list.splice(index, 1);
      if (opt != 2)
        vm.disabled = -1;
      else
        vm.disableCN = -1;
    }
    else {
      if (opt == 1) {
        list.push({
          "message": "OrderNo: " + vm.data.orderId,
          "to": vm.data.s_email,
          "id": checkbox,
          "languageCode": "SE",
          "from": this.fromEmail
        });
      }
      else if (opt == 2) {
        //other options
        list.push({'id': checkbox});
        if (checkbox == 'CN22') {
          vm.disableCN = 1;
        }
        if (checkbox == 'CN23') {
          vm.disableCN = 0;
        }
      }
      else {
        let obj = {};
        let obj1 = {};
        let
          id = this.service_id;

        if (id == 'BREVPOST') {
          if (checkbox == 'PRIO') {
            this.disabled = 1;
            index = list.findIndex(function (el) {
              return (el.id === 'EBREV');
            });
            if (index > -1) {
              return false;
            }
          }
          if (checkbox == 'EBREV') {
            this.disabled = 0;
            index = list.findIndex(function (el) {
              return (el.id === 'PRIO');
            });
            if (index > -1) {
              return false;
            }
          }
          obj = {"id": checkbox};
        }
        if (id == 'P18') {
          obj = {"id": checkbox, "text3": vm.phoneNumberShipp, "text4": vm.data.s_email};
        }
        if (id == 'P19') {
          if (checkbox == 'NOTSMS')
            obj = {"id": checkbox, "misc": vm.phoneNumberShipp};
          if (checkbox == 'NOTEMAIL')
            obj = {"id": checkbox, "misc": vm.data.s_email};
        }
        if (id == 'PUA') {
          if (checkbox == 'NOTSMS')
            obj = {"id": checkbox, "misc": vm.phoneNumberShipp};
          if (checkbox == 'NOTEMAIL')
            obj = {"id": checkbox, "misc": vm.data.s_email};
        }
        if (id == 'BREKD') {
          obj = {"id": checkbox, "misc": vm.phoneNumberShipp};
        }
        if (id == 'BREKI') {
          if (checkbox == 'NOINSU') {
            this.disabled = 1;
            index = list.findIndex(function (el) {
              return (el.id === 'INSU');
            });
            if (index > -1) {
              return false;
            }
          }
          if (checkbox == 'INSU') {
            this.disabled = 0;
            index = list.findIndex(function (el) {
              return (el.id === 'NOINSU');
            });
            if (index > -1) {
              return false;
            }
          }
          obj = {"id": checkbox};
        }
        if (id == 'P17') {
          obj = {"id": checkbox, "text3": vm.phoneNumberShipp, "text4": vm.data.s_email};
        }
        if (id == 'P34') {
          obj = {"id": checkbox};
        }
        list.push(obj);
      }
    }
  };

  exists(checkbox, list, index) {
    let
      obj = list.filter(function (obj) {
        return obj.id === checkbox;
      })[0];
    if ((this.service_id == 'BREVPOST' || this.service_id == 'BREKI' || this.service_id == 'PUA') && obj != undefined && index == 0)
      this.disabled = 1;
    if ((this.service_id == 'BREVPOST' || this.service_id == 'BREKI' || this.service_id == 'PUA') && obj != undefined && index == 1)
      this.disabled = 0;
    return obj;
  };

  saveComment() {
    if (this.comment) {
      let
        vm = this;
      let
        saveData = {'user_id': '0', 'order_id': vm.data.order_id, 'comment': vm.comment}
      vm.OrdersDataProvider.saveComments(saveData).then(function (res) {
        if (res.exist == '0') {
          vm.comments.push(res);
        }
      });
    }
  }

  removeComment(cid) {
    let
      vm = this;
    vm.OrdersDataProvider.removeComment(cid).then(function (res) {
      let
        index = vm.comments.findIndex(function (el) {
          return (el.id === cid);
        });
      if (index !== -1) {
        vm.comments.splice(index, 1);
      }
    });
  }

  getStatusLog(order_id) {
    let
      vm = this;
    vm.OrdersDataProvider.getOrderStatusLogs(order_id).then(function (logs) {
      //vm.statusLog=logs;
      vm.productionStatus = logs.filter(function (obj) {
        return obj.status_to === 1;
      })[0];
      if (vm.productionStatus != undefined) {
        vm.newTimeSpent = vm.getTimeSpent(new Date(vm.productionStatus.created_at), vm.mydate);
      }
      else {
        vm.newTimeSpent = undefined;
      }
      vm.readyShipStatus = logs.filter(function (obj) {
        return obj.status_to === 2;
      })[0];
      if (vm.readyShipStatus != undefined) {
        vm.productionTimeSpent = vm.getTimeSpent(new Date(vm.readyShipStatus.created_at), new Date(vm.productionStatus.created_at));
      }
      else {
        vm.productionTimeSpent = undefined;
      }
      vm.shippedStatus = logs.filter(function (obj) {
        return obj.status_to === 3;
      })[0];
      if (vm.shippedStatus != undefined) {
        vm.readyShipTimeSpent = vm.getTimeSpent(new Date(vm.shippedStatus.created_at), new Date(vm.readyShipStatus.created_at));
      }
      else {
        vm.readyShipTimeSpent = undefined;
      }
      vm.invoicedStatus = logs.filter(function (obj) {
        return obj.status_to === 4;
      })[0];
      if (vm.invoicedStatus != undefined) {
        vm.shippedTimeSpent = vm.getTimeSpent(new Date(vm.invoicedStatus.created_at), new Date(vm.shippedStatus.created_at));
      }
      else {
        vm.shippedTimeSpent = undefined;
      }
      vm.finishedStatus = logs.filter(function (obj) {
        return obj.status_to === 5;
      })[0];
      if (vm.finishedStatus != undefined) {
        // vm.paidTimeSpent = vm.getTimeSpent(new Date(vm.finishedStatus.created_at), new Date(vm.paidStatus.created_at));
        vm.invoicedTimeSpent = vm.getTimeSpent(new Date(vm.finishedStatus.created_at), new Date(vm.invoicedStatus.created_at));
      }
      else {
        // vm.paidTimeSpent = undefined;
        vm.invoicedTimeSpent = undefined;
      }
      vm.paidStatus = logs.filter(function (obj) {
        return obj.status_to === 6;
      })[0];
      if (vm.paidStatus != undefined) {
        vm.finishedTimeSpent = vm.getTimeSpent(new Date(vm.paidStatus.created_at), new Date(vm.finishedStatus.created_at));
      }
      else {
        vm.finishedTimeSpent = undefined;
      }
      vm.cancelledStatus = logs.filter(function (obj) {
        return obj.status_to === 7;
      })[0];
      if (vm.cancelledStatus != undefined) {
        vm.cancelledTimeSpent = vm.getTimeSpent(new Date(vm.cancelledStatus.created_at), vm.mydate);
      }
      else {
        vm.cancelledTimeSpent = undefined;
      }
      let
        remakeStatus = logs.filter(function (obj) {
          return obj.status_to === 8;
        })[0];
    });
  }

  getTimeSpent(date_future, date_now) {
    let
      delta = Math.abs(date_future - date_now) / 1000;
    let
      days = Math.floor(delta / 86400);
    delta -= days * 86400;
    let
      hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;
    let
      minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;
    let
      seconds = delta % 60;

    let returnData = '';
    if (days > 0) {
      returnData += days + ' day ';
    }
    returnData += ("0" + hours).slice(-2) + ' : ' + ("0" + minutes).slice(-2) + ' : ' + ("0" + seconds).slice(-2);
    return returnData;
  }

  changeStatus(status, id, old_status) {
    if (!status) {
      return false;
    }
    let
      vm = this;
    let
      data = {'invoice_status': status, 'ids': [id], 'status': [old_status]}
    vm.OrdersDataProvider.updateOrderStatus(data).then(function (resp) {
      vm.data.invoice_status = resp.invoice_status;
      vm.getStatusLog(id);
    })
  }

  sendShippedMail(order_id) {
    let
      vm = this;
    vm.OrdersDataProvider.sendShippedMail(order_id).then(function (resp) {
      vm.shippedMail = 1;
      vm.data.shipped_mail = 1;
    })
  }

  sendInvoiceMail(order_id) {
    let
      vm = this;
    vm.OrdersDataProvider.sendInvoiceMail(order_id).then(function (resp) {
      vm.invoiceMail = 1;
      vm.data.invoice_mail = 1;
    })
  }

  sendCollectionMail(order_id) {
    let
      vm = this;
    vm.OrdersDataProvider.sendCollectionMail(order_id).then(function (resp) {
      vm.invoiceMail = 1;
      vm.data.collection_mail = 1;
    })
  }

  sendReceiptMail(order_id) {
    let
      vm = this;
    vm.OrdersDataProvider.sendReceiptMail(order_id).then(function (resp) {
      vm.invoiceMail = 1;
      vm.data.receipt_mail = 1;
    })
  }
  sendReviewMail(order_id) {
    let
      vm = this;
    vm.OrdersDataProvider.sendReviewMail(order_id).then(function (resp) {
      vm.data.review_mail = 1;
    })
  }
  sendPaperInvoiceMail(order_id) {
    let
      vm = this;
    vm.OrdersDataProvider.sendPaperInvoiceMail(order_id).then(function (resp) {
      vm.paperInvoiceMail = 1;
      vm.data.paper_invoice_mail = 1;
    })
  }
  sendReminderInvoiceMail(order_id) {
    let
      vm = this;
    vm.OrdersDataProvider.sendReminderInvoiceMail(order_id).then(function (resp) {
      vm.paperInvoiceMail = 1;
      vm.data.reminder_mail = 1;
    })
  }
  resetStatus(id) {
    let
      vm = this;
    vm.OrdersDataProvider.resetOrderStatus(id).then(function (resp) {
      vm.data.invoice_status = '0';
      vm.getStatusLog(id);
    })
  }

  generateInvoice() {
    let
      vm = this;
    let
      theUrl = vm.APPLICATION_URL + '/api/svea/invoice/deliver/' + vm.data.sveaOrderId;
    let
      xmlHttp = new XMLHttpRequest();
    xmlHttp.open("GET", theUrl, false); // false for synchronous request
    xmlHttp.send(null);
    let
      resp = JSON.parse(xmlHttp.response);
    if (resp.resultcode == '0') {
      vm.data.svea_invoice_id = resp.invoiceId;
      let
        data = {'svea_invoice_id': vm.data.svea_invoice_id, 'id': vm.$state.params.id}
      vm.OrdersDataProvider.updateInvoiceId(data).then(function (resp) {

      })
    }
    else {
      alert(resp.errormessage);
      vm.data.errorInvoice = resp.errormessage;
    }
  }

  sendShipment(form) {
    let
      vm = this;
    vm.__loading = true;
	if (this.service_id == 'BREVPOST'){
    var body =
      {
        "sender": {
          "quickId": "1"
        },
        "receiver": {
          "phone": vm.phoneNumberShipp,
          "email": vm.data.s_email,
          "name": (vm.data.s_company_name) ? vm.data.s_company_name : vm.data.s_fullName,
          "address1": (vm.data.s_company_name) ? vm.data.s_fullName : vm.data.s_street,
          "zipcode": vm.data.s_zipCode,
          "city": vm.data.s_locality,
          "country": (vm.data.s_country) ? vm.data.s_country : "SE",
          "contact": vm.data.s_fullName,
          "mobile": vm.phoneNumberShipp
        },
        "service": {
          "id": vm.service_id,
          "paymentMethodType": "INVODN",
          "nonDeliveryType": "RETURN"
        },
        "parcels": [{
          "copies": vm.parcelsCopies,
		  "packageCode": "PC",
          "weight": vm.parcelsWeight / 1000,
          "contents": "Advertising Signs",
          "valuePerParcel": false
        }],
        "orderNo": vm.data.orderId,
        "senderReference": "OrderNo: " + vm.data.orderId
      };
	  }
	  else {
    var body =
      {
        "sender": {
          "quickId": "1"
        },
        "receiver": {
          "phone": vm.phoneNumberShipp,
          "email": vm.data.s_email,
          "name": (vm.data.s_company_name) ? vm.data.s_company_name : vm.data.s_fullName,
          "address1": (vm.data.s_company_name) ? vm.data.s_fullName : vm.data.s_street,
          "zipcode": vm.data.s_zipCode,
          "city": vm.data.s_locality,
          "country": (vm.data.s_country) ? vm.data.s_country : "SE",
          "contact": vm.data.s_fullName,
          "mobile": vm.phoneNumberShipp
        },
        "service": {
          "id": vm.service_id,
          "paymentMethodType": "INVO",
          "nonDeliveryType": "RETURN"
        },
        "parcels": [{
          "copies": vm.parcelsCopies,
		  "packageCode": "PC",
          "weight": vm.parcelsWeight / 1000,
          "contents": "Advertising Signs",
          "valuePerParcel": false
        }],
        "orderNo": vm.data.orderId,
        "senderReference": "OrderNo: " + vm.data.orderId
      }
	  }
		  
		  
		  
    if (vm.selected.length > 0)
      body.service.addons = vm.selected;
    if (vm.selectedOpt.length > 0)
      body.options = vm.selectedOpt;
    if (vm.data.s_company_name) {
      body.receiver.address2 = vm.data.s_street;
    }
    if (vm.data.reference_no) {
      body.senderReference = vm.data.reference_no;
    }
    else {
      body.senderReference = "OrderNo: " + vm.data.orderId
    }
    //other options
    if (vm.selectedOthrOpt.length > 0) {
      let
        indexCN22 = vm.selectedOthrOpt.findIndex(function (el) {
          return (el.id === "CN22");
        });
      if (indexCN22 > -1) {
        body.customsDeclaration = {
          "printSet": ["cn22"]
        };
      }
      let
        indexCN23 = vm.selectedOthrOpt.findIndex(function (el) {
          return (el.id === "CN23");
        });
      if (indexCN23 > -1) {
        body.customsDeclaration = {
          "invoiceNo": vm.data.orderId + "-" + new Date().getFullYear().toString().substr(-2) + ("0" + (new Date().getMonth() + 1)).slice(-2) + ("0" + new Date().getDate()).slice(-2),
          "currencyCode": vm.data.currency,
          "explanation": "Commercial",
		  "invoiceType": "standard",
          "printSet": ["cn23", "proforma"]
        };
        if (vm.data.delivery_price > 0)
          body.customsDeclaration.freightCharges = vm.data.delivery_price.toFixed(2);
      }
      if (indexCN22 > -1 || indexCN23 > -1) {
        body.customsDeclaration.importExportType = "OTHER";
        body.customsDeclaration.sender = {
          "quickId": "1",
          "vatNo": "SE5590289186"
        };
        body.customsDeclaration.lines = [{
          "statNo": "49119900",
          "subStatNo1": "4099",
          "value": vm.data.amount.toFixed(2),
          "contents": "Advertising signs",
          "copies": vm.parcelsCopies,
		  "packageCode": "PC",
          "netWeight": vm.parcelsWeight / 1000,
          "sourceCountryCode": "SE",
          "valuesPerItem": true
        }];
      }
    }
    let
      url = "https://api.unifaun.com/rs-extapi/v1/stored-shipments";
    let
      token = vm.UNIFAUN_ID + ":" + vm.UNIFAUN_SECRET;
    let
      hash = btoa(token);
    let
      auth = "Basic " + hash;

    let
      xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader("Authorization", auth);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 201) {
        let
          resp = xhr.response;
        //check response invalid
        let err = "Not sent to Unifaunonline, see below error/s :- \n";
        if (vm.isJson(resp)) {
          let
            response = JSON.parse(resp);
          if (response.status == 'INVALID') {
            for (var i = 0; i < response.statuses.length; i++) {
              err += (i + 1) + ". " + response.statuses[i].field + " " + response.statuses[i].messageCode + " - " + response.statuses[i].message + "\n"
            }
            vm.$timeout(function () {
              alert(err);
            }, 1000);
          }
        }
        else {
          if (window.DOMParser) {
            let
              parser = new DOMParser();
            var xmlDoc = parser.parseFromString(resp, "text/xml");
          } else {
            var xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
            xmlDoc.async = false;
            xmlDoc.loadXML(resp);
          }
          if (xmlDoc.getElementsByTagName("status")[0].childNodes[0].nodeValue == 'INVALID') {
            let
              x = xmlDoc.getElementsByTagName("statuses")[0].childNodes;
            for (var i = 0; i < x.length; i++) {
              err += (i + 1) + ". " + x[i].getElementsByTagName("field")[0].childNodes[0].nodeValue + " " + x[i].getElementsByTagName("messageCode")[0].childNodes[0].nodeValue + " - " + x[i].getElementsByTagName("message")[0].childNodes[0].nodeValue + "\n"
            }
            vm.$timeout(function () {
              alert(err);
            }, 1000);
          }
        }
        let
          saveShipmentResp = {'order_id': vm.data.order_id, 'resp': resp}
        vm.OrdersDataProvider.saveShipmentResp(saveShipmentResp).then(function (result) {
          vm.shipShow = 0
          vm.data.shipped = 1;
          vm.__loading = false;
        });
      }
    }
    xhr.send(JSON.stringify(body));
    return
  }

  download(file, item) {
    let
      vm = this;
    item.__loading = true;
    let fileUrl = vm.APPLICATION_URL + '/' + file;
    let img = new Image();
    img.onload = function () {
      let
        url = vm.APPLICATION_URL + '/api/set-dencity';
      let data = new FormData();
      data.append('images[0][s]', 1);
      data.append('images[0][w]', this.width);
      data.append('images[0][h]', this.height);
      data.append('images[0][source]', file);
      let
        xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          let
            resp = JSON.parse(xhr.response);
          // png to svg from imagemagick
          let imageName = resp.images[0].convertedPath.substr(1);
          vm.OrdersDataProvider.tosvg({'image': imageName}).then(function (res) {
            item.__loading = false;
            if (res.success == '1') {
              if (res.convertedFile) {
                vm.downloadSvg(vm.APPLICATION_URL + '/' + res.convertedFile);
              }
            }
            else {
              alert('Something went wrong while converting image data');
              return;
            }
          });
        }
      }
      xhr.send(data);
      return
    };
    img.src = fileUrl;
  }

  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  downloadSvg(file) {
    let dl = document.createElement("a");
    document.body.appendChild(dl);
    dl.setAttribute("target", '_blank');
    dl.setAttribute("href", file);
    dl.setAttribute("download", 'export.svg');
    dl.click();
  }

  downloadSvgBNW(item) {
    item.__loading = true;
    let
      url = this.APPLICATION_URL + '/editor#printbw-' + item.unique_id;
    window.open(url);
    item.__loading = false;
  }

  downloadSvgColor(item) {
    item.__loading = true;
    let
      url = this.APPLICATION_URL + '/editor#printrc-' + item.unique_id;
    window.open(url);
    item.__loading = false;
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/orders/components/view/controller.js
 **/